import { render, staticRenderFns } from "./pernoctas.vue?vue&type=template&id=ddd4ce66&"
import script from "./pernoctas.vue?vue&type=script&lang=js&"
export * from "./pernoctas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports